import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mb-n10 mb-lg-n20 z-index-2" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "text-center mb-17" }
const _hoisted_4 = { class: "fs-1 text-dark mb-5" }
const _hoisted_5 = { class: "fs-6 text-muted mb-10" }
const _hoisted_6 = { class: "row w-100 gy-10 mb-md-20" }
const _hoisted_7 = { class: "col-md-4 px-5" }
const _hoisted_8 = { class: "text-center mb-10 mb-md-0" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("img", {
  src: "/media/illustrations/sketchy-1/2.png",
  class: "mh-125px mb-9",
  alt: ""
}, null, -1)
const _hoisted_10 = { class: "d-flex flex-center mb-5" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "badge badge-circle badge-light-success fw-bold p-5 me-3 fs-3" }, "1", -1)
const _hoisted_12 = { class: "fs-5 fs-lg-3 fw-bold text-dark" }
const _hoisted_13 = { class: "fw-semibold text-gray-600" }
const _hoisted_14 = { class: "col-md-4 px-5" }
const _hoisted_15 = { class: "text-center mb-10 mb-md-0" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("img", {
  src: "/media/illustrations/sketchy-1/8.png",
  class: "mh-125px mb-9",
  alt: ""
}, null, -1)
const _hoisted_17 = { class: "d-flex flex-center mb-5" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "badge badge-circle badge-light-success fw-bold p-5 me-3 fs-3" }, "2", -1)
const _hoisted_19 = { class: "fs-5 fs-lg-3 fw-bold text-dark" }
const _hoisted_20 = { class: "fw-semibold text-gray-600" }
const _hoisted_21 = { class: "col-md-4 px-5" }
const _hoisted_22 = { class: "text-center mb-10 mb-md-0" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("img", {
  src: "/media/illustrations/sketchy-1/12.png",
  class: "mh-125px mb-9",
  alt: ""
}, null, -1)
const _hoisted_24 = { class: "d-flex flex-center mb-5" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", { class: "badge badge-circle badge-light-success fw-bold p-5 me-3 fs-3" }, "3", -1)
const _hoisted_26 = { class: "fs-5 fs-lg-3 fw-bold text-dark" }
const _hoisted_27 = { class: "fw-semibold text-gray-600" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FreeTestSubscription = _resolveComponent("FreeTestSubscription")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.translate("How does Inboxino work ?")), 1),
          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.translate(
                "Inboxino is an internal and external messaging assistant that allows you to send bulk messages with your own number to multiple recipients on messaging apps such as WhatsApp Telegram Eitaa and Bale You can send text messages photos videos audios and more Additionally you can set up an auto-reply for your own number or business so whenever someone messages you on any messaging platform you can respond with predefined options Furthermore you can connect your website application or CRM to Inboxino via the web service to send automated notifications"
              )) + ". ", 1),
          _createVNode(_component_FreeTestSubscription)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.translate("Create Subscription")), 1)
              ]),
              _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.translate(
                    "Click on My Subscriptions in the side menu and create a new subscription on the opened page"
                  )), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _hoisted_16,
              _createElementVNode("div", _hoisted_17, [
                _hoisted_18,
                _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.translate("Connect Messengers")), 1)
              ]),
              _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.translate(
                    "After creating the subscription go to Manage Platforms by clicking on the button in My Subscriptions menu and connect your messengers"
                  )), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _hoisted_23,
              _createElementVNode("div", _hoisted_24, [
                _hoisted_25,
                _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.translate("Enjoy Inboxino")), 1)
              ]),
              _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.translate(
                    "Now Inboxino is ready to serve you Use our services from the menu and enjoy"
                  )), 1)
            ])
          ])
        ])
      ])
    ])
  ]))
}